module.exports = __webpack_public_path__ + "img/world-cup.5f7133f1.png";